import { Splide } from "@splidejs/splide";

const carousel = () => {
  const targetElms = document.getElementsByClassName('js-FvSlider');
  if(targetElms.length === 0) return;
  
  for(const targetElm of targetElms) {
    let splideInstance = null;
    const breakpoint = 576;
    
    const initSplide = () => {
      const isSP = window.innerWidth < breakpoint;
      
      if (isSP && !splideInstance) {
        // SPでSplideを起動
        const speed = 1000;
        let options = {
          type: "fade",
          rewind: true,
          speed: speed,
          interval: 3000,
          perPage: 1,
          arrows: false,
          pagination: false,
          pauseOnHover: false, // ホバーしても停止しない
          pauseOnFocus: false, // フォーカスしても停止しない
          focus: 'center',
          autoplay: true,
          reducedMotion: {
            speed: speed,
            interval: 3000,
            autoplay: true,
            pauseOnHover: false, // ホバーしても停止しない
            pauseOnFocus: false, // フォーカスしても停止しない
          }
        };
        
        // data属性でカスタマイズ
        if(targetElm.dataset.speed) {
          options.speed = parseInt(targetElm.dataset.speed);
          options.rewindSpeed = parseInt(targetElm.dataset.speed);
          options.reducedMotion.speed = parseInt(targetElm.dataset.speed);
          options.reducedMotion.rewindSpeed = parseInt(targetElm.dataset.speed);
        }
        
        if(targetElm.dataset.gap) {
          options.gap = targetElm.dataset.gap;
        }
        
        if(targetElm.dataset.perpage) {
          options.perPage = parseInt(targetElm.dataset.perpage);
        }
        
        splideInstance = new Splide(targetElm, options);
        splideInstance.mount();
      } else if (!isSP && splideInstance) {
        // PCでSplideを破棄
        splideInstance.destroy();
        splideInstance = null;
      }
    };
    
    // 初期化
    initSplide();
    
    // リサイズ時に再判定（デバウンス付き）
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initSplide();
      }, 250);
    });
  }
};

const init = () => {
  carousel();
};

export default init;